
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { checkCompanyName, checkUserName } from 'services/clients.service';
export interface RegisterState {
	isUsernameExists: boolean;
	isCompanyNameExists: boolean;
}

const initialState: RegisterState = {
	isUsernameExists: false,
	isCompanyNameExists: false,
};

const registerSlice = createSlice({
  name:'registerState',
  initialState,
  reducers:{
    CHECK_CLIENT_COMPANY_NAME:(state, action:PayloadAction<any>):RegisterState=>{
        return {
            ...state,
            isCompanyNameExists: action.payload,
        };
    },
    CHECK_USERNAME:(state, action:PayloadAction<any>):RegisterState=>{
        return {
            ...state,
            isUsernameExists: action.payload,
        };
    }
  }
})

export const { CHECK_CLIENT_COMPANY_NAME ,CHECK_USERNAME } = registerSlice.actions
export default registerSlice.reducer


export const checkUsernameThunk = (username: string):any => async (dispatch: any) => {
	console.warn(' i am in thunk');
	try {
		await checkUserName(username);
		dispatch(CHECK_USERNAME(false));
	} catch (error) {
		dispatch(CHECK_USERNAME(true));
	}
};
export const checkClientCompanyNameThunk = (companyName: string):any => async (
	dispatch: any,
) => {
	try {
		await checkCompanyName(companyName);
		dispatch(CHECK_CLIENT_COMPANY_NAME(false));
	} catch (error) {
		dispatch(CHECK_CLIENT_COMPANY_NAME(true));
	}
};